// extracted by mini-css-extract-plugin
export var arrows = "_8f-6";
export var decrementer = "_8f-a";
export var disabled = "_8f-4";
export var error = "_8f-1";
export var hiddenText = "_8f-b";
export var incrementer = "_8f-9";
export var input = "_8f-8";
export var inputWrapper = "_8f-0";
export var leadingIcon = "_8f-c";
export var readonly = "_8f-3";
export var regular = "_8f-7";
export var small = "_8f-5";
export var warning = "_8f-2";